import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { CONFIDENCE_BADGE_CLASS, normalizeConfidence } from './formatMetadata';

/** Pill next to a section heading saying how trustworthy its numbers are. */
export const ConfidenceBadge: React.FC<{ confidence?: string }> = ({ confidence }) => {
  const { t } = useTranslation();
  const level = normalizeConfidence(confidence);

  return (
    <Badge
      variant="outline"
      className={cn(
        'h-[18px] px-1 text-[0.65rem]',
        'revy-cjk font-normal leading-[1.5]',
        CONFIDENCE_BADGE_CLASS[level],
      )}
    >
      {t(`cad.metadata.confidence.${level}`)}
    </Badge>
  );
};
